"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = require("react-loadable");

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Loading = function Loading() {
  return _react2.default.createElement(
    "div",
    null,
    "Loading..."
  );
};

// Dynamic import function for components

var SurveyModule = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/SurveyModule");
  },
  loading: Loading
});

var DrawingRegisterSearch = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/master/drawing-register/Search");
  },
  loading: Loading
});

var DrawingRegisterEntry = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/master/drawing-register/Entry");
  },
  loading: Loading
});

var DrawingRegisterView = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/master/drawing-register/View");
  },
  loading: Loading
});

var DrawingRegisterModify = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/master/drawing-register/Modify");
  },
  loading: Loading
});

var FileRegisterSearch = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/master/file-register/Search");
  },
  loading: Loading
});

var FileRegisterEntry = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/master/file-register/Entry");
  },
  loading: Loading
});

var FileRegisterView = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/master/file-register/View");
  },
  loading: Loading
});

var FileRegisterModify = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/master/file-register/Modify");
  },
  loading: Loading
});

var AlignmentRegisterSearch = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/master/alignment-register/Search");
  },
  loading: Loading
});

var AlignmentRegisterEntry = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/master/alignment-register/Entry");
  },
  loading: Loading
});

var AlignmentRegisterView = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/master/alignment-register/View");
  },
  loading: Loading
});
var AlignmentRegisterModify = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/master/alignment-register/Modify");
  },
  loading: Loading
});

var SorChargeRateMasterSearch = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/master/sor-charge-rate-master/Search");
  },
  loading: Loading
});
var SorChargeRateMasterModify = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/master/sor-charge-rate-master/Modify");
  },
  loading: Loading
});

var LandInformationMasterSearch = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/master/land-information/Search");
  },
  loading: Loading
});

var LandInformationMasterEntry = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/master/land-information/Create");
  },
  loading: Loading
});

var UserWardPermissionSurveyEstate = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/UserWardPermission/index.js");
  },
  loading: Loading
});

var MiscDemandRateSearch = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/master/MiscDemandRate/Search");
  },
  loading: Loading
});
var MiscDemandRateEntry = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/master/MiscDemandRate/Create");
  },
  loading: Loading
});

var SORWorkflowSearch = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/workflow/SOR/Entry/Search");
  },
  loading: Loading
});
var SORWorkflowEntry = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/workflow/SOR/Entry");
  },
  loading: Loading
});
var SORHAUDAList = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/workflow/SOR/HAUDA/Search");
  },
  loading: Loading
});
var SORHAUDADetails = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/workflow/SOR/HAUDA/Details");
  },
  loading: Loading
});
var DraftsmanList = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/workflow/SOR/Draftsman/Search");
  },
  loading: Loading
});
var DraftsmanDetails = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/workflow/SOR/Draftsman/Details");
  },
  loading: Loading
});
var SAEList = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/workflow/SOR/SAE/Search");
  },
  loading: Loading
});

var SAEDetails = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/workflow/SOR/SAE/Details/index");
  },
  loading: Loading
});
var SAEInspectionEntry = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/workflow/SOR/SAE/Inspection");
  },
  loading: Loading
});

var AEList = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/workflow/SOR/AE/Search");
  },
  loading: Loading
});

var AEDetails = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/workflow/SOR/AE/Details/index.js");
  },
  loading: Loading
});
var Enchroachment = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/workflow/SOR/AE/Encroachment/index.js");
  },
  loading: Loading
});
var SpecialCase = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/workflow/SOR/AE/SpecialCase/index.js");
  },
  loading: Loading
});
var Requisition = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/workflow/SOR/AE/Requisition/index.js");
  },
  loading: Loading
});
//Development Fees
var DevelopmentFeesSearch = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/workflow/DevelopmentFees/Search");
  },
  loading: Loading
});
var DevelopmentFeesEntry = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/workflow/DevelopmentFees/Entry");
  },
  loading: Loading
});
//Occcupier Details
var OccupierDeatilsSearch = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/master/OccupierDetails/Search");
  },
  loading: Loading
});
var OccupierDeatilsEntry = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/master/OccupierDetails/Create");
  },
  loading: Loading
});
var RefusalMemo = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/workflow/SOR/AE/RefusalMemo/index.js");
  },
  loading: Loading
});
var WorkFlowOccupierDetailsSearch = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/workflow/OccupierDetails/Search");
  },
  loading: Loading
});
var WorkFlowOccupierDetailsControlSearch = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/workflow/OccupierDetails/ControlSearch");
  },
  loading: Loading
});
var WorkFlowOccupierDetailsEntry = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/workflow/OccupierDetails/Entry");
  },
  loading: Loading
});
//Land Acquisition
var WorkFlowLandAcquisitionSearch = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/workflow/LandAcquisition/Search");
  },
  loading: Loading
});
var WorkFlowLandAcquisitionEntry = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/workflow/LandAcquisition/Entry");
  },
  loading: Loading
});
//Dev-fees correction
var DevFeesCorrectionSearch = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/DevFeesCorrection/Search");
  },
  loading: Loading
});
var DevFeesCorrectionEntry = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/DevFeesCorrection/Entry");
  },
  loading: Loading
});
var DevFeesCorrectionView = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/DevFeesCorrection/View");
  },
  loading: Loading
});
// Land Delete
var LandDeleteSearch = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/LandDelete/Search");
  },
  loading: Loading
});
//Dev fees non recorded road
var DevFeesNonRecoredRoadSearch = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/DevFeesForNonRecordedRoad/Search");
  },
  loading: Loading
});
var DevFeesNonRecoredRoadEntry = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/DevFeesForNonRecordedRoad/Entry");
  },
  loading: Loading
});
var DevFeesNonRecoredRoadView = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/DevFeesForNonRecordedRoad/View");
  },
  loading: Loading
});

var ReprintCorrection = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/workflow/SOR/Correction Reprint/index.js");
  },
  loading: Loading
});
var UploadedDocuments = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/workflow/SOR/UploadedDocuments/index.js");
  },
  loading: Loading
});

//misc demand
var miscDemandForm = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/MiscDemand/MiscDemandForm/MiscDemandForm");
  },
  loading: Loading
});
var miscDemandSearchList = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/MiscDemand/SearchMiscDemand/MiscDemandSearch");
  },
  loading: Loading
});

// LEASE / RENT DEMAND

var ControlNoSearchList = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/LeaseRentDemand/SearchControllNo");
  },
  loading: Loading
});

var createSingleDemand = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/LeaseRentDemand/SingleDemand/CreateSingleDemand");
  },
  loading: Loading
});

var demandSearchList = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/LeaseRentDemand/CancelDemand/DemandSearchForCancel");
  },
  loading: Loading
});
var dateExtensionForm = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/LeaseRentDemand/CancelDemand/DateExtensionScreen");
  },
  loading: Loading
});
var batchDemandGeneratedFrom = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/LeaseRentDemand/BatchDemand/BatchDemandGeneratedFrom");
  },
  loading: Loading
});

var BuildingNOCPendingList = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/BuilddingIntegration/index.js");
  },
  loading: Loading
});
var BuildingNOCDocumentUpload = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/BuilddingIntegration/upload.js");
  },
  loading: Loading
});

var CommonReport = (0, _reactLoadable2.default)({
  loader: function loader() {
    return import("../Screens/Report/index.js");
  },
  loading: Loading
});
// Example route configuration
var routes = [{
  path: "egov-survey",
  component: SurveyModule,
  needsAuthentication: true,
  options: {
    hideFooter: true,
    title: "SurveyModule",
    hideTitle: true,
    hideBackButton: true
  }
},
// Add more route configurations as needed

{
  path: "survey/drawing-master/search",
  component: DrawingRegisterSearch,
  needsAuthentication: true
}, {
  path: "survey/drawing-master/entry",
  component: DrawingRegisterEntry,
  needsAuthentication: true
}, {
  path: "survey/drawing-master/view",
  component: DrawingRegisterView,
  needsAuthentication: true
}, {
  path: "survey/drawing-master/modify",
  component: DrawingRegisterModify,
  needsAuthentication: true
}, {
  path: "survey/file-master/entry",
  component: FileRegisterEntry,
  needsAuthentication: true
}, {
  path: "survey/file-master/view",
  component: FileRegisterView,
  needsAuthentication: true
}, {
  path: "survey/file-master/modify",
  component: FileRegisterModify,
  needsAuthentication: true
}, {
  path: "survey/file-master/search",
  component: FileRegisterSearch,
  needsAuthentication: true
}, {
  path: "survey/alignment-master/search",
  component: AlignmentRegisterSearch,
  needsAuthentication: true
}, {
  path: "survey/alignment-master/entry",
  component: AlignmentRegisterEntry,
  needsAuthentication: true
}, {
  path: "survey/alignment-master/view",
  component: AlignmentRegisterView,
  needsAuthentication: true
}, {
  path: "survey/alignment-master/modify",
  component: AlignmentRegisterModify,
  needsAuthentication: true
}, {
  path: "survey/sor-charge-rate-master/search",
  component: SorChargeRateMasterSearch,
  needsAuthentication: true
}, {
  path: "survey/sor-charge-rate-master/modify",
  component: SorChargeRateMasterModify,
  needsAuthentication: true
}, {
  path: "survey/misc-demand-rate-master/entry",
  component: MiscDemandRateEntry,
  needsAuthentication: true
}, {
  path: "survey/misc-demand-rate-master/search",
  component: MiscDemandRateSearch,
  needsAuthentication: true
},
// LEASE/RENT DEMAND Routes
{
  path: "survey/lease-rent-demand/control-numbers",
  component: ControlNoSearchList,
  needsAuthentication: true
}, {
  path: "survey/lease-rent-demand/search-list",
  component: demandSearchList,
  needsAuthentication: true
}, {
  path: "survey/lease-rent-demand/date-extension-form",
  component: dateExtensionForm,
  needsAuthentication: true
}, {
  path: "survey/lease-rent-demand/batch_demand-generated",
  component: batchDemandGeneratedFrom,
  needsAuthentication: true
}, {
  path: "survey/lease-rent-demand/single-demand-generated",
  component: createSingleDemand,
  needsAuthentication: true
}, {
  path: "survey/land-information-master/search",
  component: LandInformationMasterSearch,
  needsAuthentication: true
}, {
  path: "survey/land-information-master/entry",
  component: LandInformationMasterEntry,
  needsAuthentication: true
}, {
  path: "survey/workflow/sor/search",
  component: SORWorkflowSearch,
  needsAuthentication: true
}, {
  path: "survey/workflow/sor/entry",
  component: SORWorkflowEntry,
  needsAuthentication: true
}, {
  path: "survey/workflow/sor/hauda/search",
  component: SORHAUDAList,
  needsAuthentication: true
}, {
  path: "survey/workflow/sor/hauda/details",
  component: SORHAUDADetails,
  needsAuthentication: true
}, {
  path: "survey/workflow/sor/draftsman/search",
  component: DraftsmanList,
  needsAuthentication: true
}, {
  path: "survey/workflow/sor/draftsman/details",
  component: DraftsmanDetails,
  needsAuthentication: true
}, {
  path: "survey/workflow/sor/sae/search",
  component: SAEList,
  needsAuthentication: true
}, {
  path: "survey/workflow/sor/sae/details",
  component: SAEDetails,
  needsAuthentication: true
}, {
  path: "survey/workflow/sor/sae/inspection-entry",
  component: SAEInspectionEntry,
  needsAuthentication: true
}, {
  path: "survey/workflow/sor/ae/search",
  component: AEList,
  needsAuthentication: true
}, {
  path: "survey/workflow/sor/ae/details",
  component: AEDetails,
  needsAuthentication: true
}, {
  path: "survey/workflow/sor/ae/encroachment",
  component: Enchroachment,
  needsAuthentication: true
}, {
  path: "survey/workflow/sor/ae/special-case",
  component: SpecialCase,
  needsAuthentication: true
}, {
  path: "survey/workflow/sor/ae/requisition",
  component: Requisition,
  needsAuthentication: true
}, {
  path: "survey/workflow/sor/ae/refusal-memo",
  component: RefusalMemo,
  needsAuthentication: true
}, {
  path: "survey/workflow/sor/reprint-correction",
  component: ReprintCorrection,
  needsAuthentication: true
}, {
  path: "survey/workflow/sor/uploaded-documents",
  component: UploadedDocuments,
  needsAuthentication: true
},
// MISC DEMAND ENTRY ROUTE
{
  path: "survey/misc/demand-create-from",
  component: miscDemandForm,
  needsAuthentication: true
},
// MISC DEMAND SEARCH
{
  path: "survey/misc/demand-search",
  component: miscDemandSearchList,
  needsAuthentication: true
}, {
  path: "survey/user-ward-permission/survey-estate",
  component: UserWardPermissionSurveyEstate,
  needsAuthentication: true
}, {
  path: "survey/misc-demand-rate-master/search",
  component: MiscDemandRateSearch,
  needsAuthentication: true
}, {
  path: "survey/misc-demand-rate-master/entry",
  component: MiscDemandRateEntry,
  needsAuthentication: true
},
// LEASE/RENT DEMAND Routes
{
  path: "survey/lease-rent-demand/single-demand-generated",
  component: createSingleDemand,
  needsAuthentication: true
},
//DevelopmentFees
{
  path: "survey/workflow/development-fees/search",
  component: DevelopmentFeesSearch,
  needsAuthentication: true
}, {
  path: "survey/workflow/development-fees/entry",
  component: DevelopmentFeesEntry,
  needsAuthentication: true
}, {
  path: "survey/occupier-details-master/search",
  component: OccupierDeatilsSearch,
  needsAuthentication: true
}, {
  path: "survey/occupier-details-master/entry",
  component: OccupierDeatilsEntry,
  needsAuthentication: true
}, {
  path: "survey/workflow/occupier-details/search",
  component: WorkFlowOccupierDetailsSearch,
  needsAuthentication: true
}, {
  path: "survey/workflow/occupier-details/control-search",
  component: WorkFlowOccupierDetailsControlSearch,
  needsAuthentication: true
}, {
  path: "survey/workflow/occupier-details/entry",
  component: WorkFlowOccupierDetailsEntry,
  needsAuthentication: true
}, {
  path: "survey/workflow/building-noc",
  component: BuildingNOCPendingList,
  needsAuthentication: true
}, {
  path: "survey/workflow/building-noc-upload",
  component: BuildingNOCDocumentUpload,
  needsAuthentication: true
}, {
  path: "survey/workflow/land-acquisition/search",
  component: WorkFlowLandAcquisitionSearch,
  needsAuthentication: true
}, {
  path: "survey/workflow/land-acquisition/entry",
  component: WorkFlowLandAcquisitionEntry,
  needsAuthentication: true
}, {
  path: "survey/dev-fees-correction/search",
  component: DevFeesCorrectionSearch,
  needsAuthentication: true
}, //
{
  path: "survey/dev-fees-correction/view",
  component: DevFeesCorrectionView,
  needsAuthentication: true
}, {
  path: "survey/dev-fees-correction/entry",
  component: DevFeesCorrectionEntry,
  needsAuthentication: true
}, {
  path: "survey/land-delete/search",
  component: LandDeleteSearch,
  needsAuthentication: true
}, {
  path: "survey/dev-fees-non-recorded-road/search",
  component: DevFeesNonRecoredRoadSearch,
  needsAuthentication: true
}, {
  path: "survey/dev-fees-non-recorded-road/entry",
  component: DevFeesNonRecoredRoadEntry,
  needsAuthentication: true
}, {
  path: "survey/dev-fees-non-recorded-road/view",
  component: DevFeesNonRecoredRoadView,
  needsAuthentication: true
},
//Common report
{
  path: "survey/reports/commonreports",
  component: CommonReport,
  needsAuthentication: true
}];

exports.default = routes;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-survey/Routes/module-routes.js
// module id = 3527
// module chunks = 1137